import ResolveMultiSelctOption from './ResolveMultiSelctOption.component';

export default ResolveMultiSelctOption;